<script lang="ts">
	import { _ } from 'svelte-i18n';
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import DefaultTextInput from '../../../basic/input/DefaultTextInput.svelte';
	import DefaultTextareaInput from '../../../basic/input/DefaultTextareaInput.svelte';
	import InputLabel from '../../../basic/input/InputLabel.svelte';
	import Modal from '../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../basic/modal/ModalHeader.svelte';
	import type { CreateFolder } from '../../../types/FolderTypes';
	import { handleStoreError } from '../../../stores/GeneralStore';

	interface Props {
		postFolderStore: (request: CreateFolder) => Promise<void>;
		onModalClose: () => void;
	}

	let { postFolderStore, onModalClose }: Props = $props();

	let request: CreateFolder = {
		name: '',
		shortName: '',
		memo: ''
	};

	async function handleCreate() {
		try {
			await postFolderStore(request);
			onModalClose();
		} catch (err) {
			handleStoreError('folderview.err_folder_create', err);
		}
	}
</script>

<Modal
	{onModalClose}
	onModalEnter={() => {
		handleCreate();
	}}
>
	{#snippet header()}
		<ModalHeader text={$_('folderview.lbl_folder_create_header')} />
	{/snippet}
	{#snippet content()}
		<div class="grid gap-2">
			<InputLabel label={$_('folderview.lbl_folder_short')} />
			<DefaultTextInput
				propertyName="shortName"
				maxLength={25}
				focusOnStart={true}
				bind:value={request.shortName}
			/>

			<InputLabel label={$_('folderview.lbl_folder_name')} />
			<DefaultTextInput propertyName="name" maxLength={255} bind:value={request.name} />

			<InputLabel label={$_('folderview.lbl_folder_memo')} />
			<DefaultTextareaInput maxLength={255} propertyName="memo" bind:value={request.memo} />
		</div>
	{/snippet}
	{#snippet footer()}
		<div>
			<!-- Buttons -->
			<div class="flex justify-end gap-4">
				<DefaultButton
					secondary={true}
					onClick={() => {
						onModalClose();
					}}
					text={$_('general.lbl_cancel')}
				/>
				<DefaultButton spamProtectedCall={handleCreate} text={$_('general.lbl_create')} />
			</div>
		</div>
	{/snippet}
</Modal>
